export const CATEGORY_API_PATHS = {
  categories: "/categories",
  brands: "/brands",
  categoryProducts: (slug: string, page: number, limit: number) => `/category/${encodeURIComponent(slug)}?page=${page}&limit=${limit}`,
  allProducts: (query: string) => `/products-v2?${query}`,
} as const
